
import { Base } from '../base-component';

import './link.component.scss';

export class Link extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/link/link.component.ts